var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',_vm._b({staticClass:"custom-select",attrs:{"value":_vm.value,"ripple":false,"append-icon":"las la-angle-down","full-width":false,"filled":"","hide-details":"","dense":""},on:{"change":function($event){return _vm.$emit('change', $event)}}},'v-select',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }